import { AliceAgentAppDTO, AliceAppType } from 'client/model/aliceAgentApp';

export const getAliceAppType = (app: AliceAgentAppDTO): AliceAppType | undefined => app.draft.manifest?.type;

const ALICE_APP_PATH_SEGMENT: Record<AliceAppType, string> = {
    aliceInternalAgentApp: 'internal',
    aliceExternalApp: 'external',
};

/**
 * The `internal`/`external` segment in the URL is the only thing telling the page which editor
 * to render — and each editor hardcodes the manifest `type` it persists. When a developer edits
 * that segment by hand the loaded DTO's real type can disagree with the URL, so saving would
 * silently rewrite the app's type. Re-point the pathname at the segment matching the actual type.
 *
 * Returns null when the type is unknown (a fresh draft without a manifest yet): nothing to fix.
 */
export const buildCorrectedAppPath = (pathname: string, type: AliceAppType | undefined): string | null => {
    if (!type) return null;
    return pathname.replace(/\/alice-apps\/(?:internal|external)\//, `/alice-apps/${ALICE_APP_PATH_SEGMENT[type]}/`);
};
